var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"bg-gray-4 border border-sec-5 border-box shadow-mod rounded-sm"},[(_vm.showCloseCross)?_c('CloseCross',{staticClass:"absolute top-sm right-sm",nativeOn:{"click":function($event){return _vm.$emit('close-modal')}}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }